import { render, staticRenderFns } from "./GreenCityTask.vue?vue&type=template&id=aa18b534&scoped=true&"
import script from "./GreenCityTask.vue?vue&type=script&lang=js&"
export * from "./GreenCityTask.vue?vue&type=script&lang=js&"
import style0 from "./GreenCityTask.vue?vue&type=style&index=0&id=aa18b534&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa18b534",
  null
  
)

export default component.exports